// extracted by mini-css-extract-plugin
module.exports = {"root":"NewFeaturePopup_root__3JKua","msg":"NewFeaturePopup_msg___l6I3"};